export default {
  methods: {
    initPortlet(portlet_id) {
      new window.KTPortlet(portlet_id, {
        bodyToggleSpeed: 400,
        tooltips: true,
        tools: {
          toggle: {
            collapse: 'Collapse',
            expand: 'Expand',
          },
        },
        sticky: {
          offset: 300,
          zIndex: 101,
        },
      });
    },
  },
};
